import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_EVENTS,
  REQUEST_CREATE_MASTER_EVENTS,
  SET_MASTER_EVENTS,
  SUCCESS_CREATE_MASTER_EVENTS,
  ERROR_GET_MASTER_EVENTS,
  ERROR_CREATE_MASTER_EVENTS,
  SUCCESS_DELETE_MASTER_EVENTS,
  SUCCESS_UPDATE_MASTER_EVENTS,
  REQUEST_DELETE_MASTER_EVENTS,
  REQUEST_UPDATE_MASTER_EVENTS,
  ERROR_DELETE_MASTER_EVENTS,
  ERROR_UPDATE_MASTER_EVENTS,
} from "./eventsActionTypes";

function* requestMasterEventManagement(action: Record<string, any>): any {
  try {
    const result: any = yield call(getEventsManagementMaster);
    yield put({ type: SET_MASTER_EVENTS, payload: result.data.data });
    // console.warn(result.data.data, "jhuihihi");
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_EVENTS, payload: message });
  }
}

function* requestUpdateMasterTagEventsManagement(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterEventsManagement,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_EVENTS,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_EVENTS, payload: message });
  }
}

function* requestDeleteMasterTagEventsManagement(action: Record<string, any>): any {
  try {
    yield call(deleteMasterEventsManagement, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_EVENTS,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_EVENTS, payload: message });
  }
}

function* requestCreateMasterEventsManagement(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterEventsManagement, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_EVENTS,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_EVENTS, payload: message });
  }
}

export function getEventsManagementMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/community-events`,
    withCredentials: true,
  });
}

export function createMasterEventsManagement(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/community-events`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterEventsManagement(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/community-events/${_id}`,
    withCredentials: true,
  });
}
export function updateMasterEventsManagement(payload: Record<string, any>, _id: string) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/community-events/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

const eventsManagementMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_EVENTS, requestMasterEventManagement),
    takeLatest(REQUEST_CREATE_MASTER_EVENTS, requestCreateMasterEventsManagement),
    takeLatest(REQUEST_UPDATE_MASTER_EVENTS, requestUpdateMasterTagEventsManagement),
    takeLatest(REQUEST_DELETE_MASTER_EVENTS, requestDeleteMasterTagEventsManagement),
  ]);
};

export default eventsManagementMasterSaga;
